import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "../../components/Loading";
import { STEPS } from "./Main";
import useAxios from "../../hooks/useAxios";
import ResponsiveMatchUser from "../../components/ResponsiveMatchUser";

const MatchUserStep = ({ restart, fetchedVoters, setIsWaiting, setStep,shoolAndpchNoData }) => {
  const [buttonState, setButtonState] = useState(null);
  const [isMobile, setIsMobile] = useState(false);  
  const { token } = useParams();
  const { post } = useAxios();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check immediately on component mount
    checkScreenSize();
    
    // Also listen for resize events
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleSelect = async (voter) => {
    let obj =  {
      purpose: "approve_or_wait",
      voter_id: voter.voter_id,
      token,
      ...shoolAndpchNoData
    }
    
    await post(
      process.env.REACT_APP_EMAIL_SIGNUP_API_URL,
      obj,
      (response) => {
        if (response.data.data.status === "waiting") {
          setIsWaiting(true);
          setStep(STEPS.COMPLETE_SIGNUP);
        } else if (
          response.data.data.status === "approved-needs-to-set-password"
        ) {
          setIsWaiting(false);
          setStep(STEPS.COMPLETE_SIGNUP);
        }
      }
    );

    setButtonState(null);
  };

  return (
    <div className="w-full px-20px max-w-[1336px] font-fira xl:mt-[232px] lg:mt-[190px] mt-[140px] mx-auto lg-xl:mb-20 lg:mb-15 mb-10">
      <div className="border border-gray-300 rounded-[16px] p-4 lg:p-[40px] shadow-sm w-full">
        <div className="text-center mb-[20px]">
          <h1 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-lightBlack tracking-normal uppercase font-fira">Matching Voter Record(s)</h1>
          <p className="xl:text-[28px] xl:leading-[32.6px] text-[24px] leading-normal font-fira font-normal text-cherry mt-[10px]">
            Please click the submit button on the row that matches your registered Voter Id.
          </p>
        </div>

        <div className="rounded-md mb-6">
          <div className="overflow-x-auto">
            <table className={`${!isMobile ? 'w-[1214px]' : 'w-full'}`}>
            <thead >
              {!isMobile && <tr className="border-b">
                <th className="py-3 px-4 text-left text-xl font-medium font-fira leading-[29px] w-[276px]">Voter ID</th>
                <th className="py-3 px-4 text-left text-xl font-medium font-fira leading-[29px] w-[334px]">Full Name</th>
                <th className="py-3 px-4 text-left text-xl font-medium font-fira leading-[29px] w-[492px]">Full Address</th>
                <th className="py-3 px-4"></th>
              </tr>}
            </thead>
            <tbody>
              {fetchedVoters?.map((voter) => (
                <tr key={voter.voter_id} className="border-b border-[#EBEBEB]">
                  {isMobile ? (
                    <ResponsiveMatchUser 
                      voter={voter}
                      onsubmit={() => handleSelect(voter)}
                      buttonState={buttonState}
                    />
                  ) : (
                    <>
                      <td className="py-[20px] px-4 text-xl font-normal text-lightBlack font-fira leading-[29px]">{voter.voter_id}</td>
                      <td className="py-[20px] px-4 text-xl font-normal text-lightBlack font-fira leading-[29px] capitalize">{voter.first_name} {voter.middle_name} {voter.last_name}</td>
                      <td className="py-[20px] px-4 text-xl font-normal text-lightBlack font-fira leading-[29px] capitalize">{voter.full_address}</td>
                      <td className="py-3 px-4 text-end" onClick={() => handleSelect(voter)}>
                        <button className="text-[#D30039] font-medium text-xl">
                          {buttonState === "loading" ? (
                            <div>
                              <Loading size={18} />
                            </div>
                          ) : 'SUBMIT'}
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between mt-5">
          <button className="flex items-center border border-[#D30039] px-[15px] py-[7px] text-[#D30039] text-sm md:px-[29px] md:py-[13px] md:text-[22px] md:leading-[23.4px] font-medium hover:bg-[#D30039] hover:text-white" onClick={restart}>
            <span className="xs:mr-[20px] mr-1" >&#8249;</span> BACK
          </button>
          <button className="flex items-center border border-[#D30039] px-[15px] py-[7px] text-[#D30039] text-sm md:px-[29px] md:py-[13px] md:text-[22px] md:leading-[23.4px] font-medium hover:bg-[#D30039] hover:text-white" onClick={() => setStep(STEPS.CANT_FIND_VOTER_ID)}>
            CAN'T FIND VOTER ID <span className="xs:ml-[20px] ml-1">&#8250;</span>
          </button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default MatchUserStep;
